<template>
  <v-page>
    <v-link to="/me/submissions">
      <toolbar class="mb-3" :logo="false">
        <template v-slot:left>
          <span v-if="form" class="v-toolbar__text">
            {{ form ? form.title : "..." }}
          </span>
        </template>
      </toolbar>
    </v-link>

    <div class="p-2 container">
      <grouped-form-submissions
        :form-id="formId"
        @choose="submission => chooseSubmission(submission.id)"
        @loaded="data => (form = data.form)"
      />
    </div>
  </v-page>
</template>

<script>
import Toolbar from "@/components/Toolbar"

import GroupedFormSubmissions from "@/components/form-submission/GroupedFormSubmissions"

export default {
  components: {
    Toolbar,
    GroupedFormSubmissions
  },

  data() {
    return {
      form: null
    }
  },

  computed: {
    // get form id from route params
    formId() {
      return this.$route.params.formId
    }
  },

  methods: {
    chooseSubmission(id) {
      this.$router.push(`/me/forms/${this.formId}/submissions/${id}`)
    }
  }
}
</script>
